module.exports = __webpack_public_path__ + "assets/img/hcpimg32.00c58e66.png";